import { PageShell } from "@/components/layout/PageShell";
import { PageHeaderFrame } from "@/components/layout/page-header-frame";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { PersonCard } from "@/components/people/PersonCard";
import { UnassignedSection } from "@/components/people/UnassignedSection";
import { PEOPLE_BOARD_LIMIT } from "@/components/people/people-constants";
import { usePeopleBoard } from "@/hooks/usePeopleBoard";
import { Search, UsersRound } from "lucide-react";

const People = () => {
  const { people, totalPeople, candidatesTotal, truncated, isLoading, isError, search, setSearch } = usePeopleBoard();

  return (
    <PageShell>
      <PageHeaderFrame
        icon={UsersRound}
        title="People"
        description={
          totalPeople > 0
            ? <><span className="font-medium text-foreground">{totalPeople}</span> {totalPeople === 1 ? "person" : "people"} with open deliverables, in PPP order — 1 focus, 2 queue per person</>
            : "Who is on what, in PPP order — 1 focus, 2 queue per person"
        }
      />

      <div className="relative mb-6 w-full sm:w-80">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Search person or deliverable…" value={search} onChange={(e) => setSearch(e.target.value)} className="pl-9" />
      </div>
      {truncated && (
        <p className="mb-4 text-xs text-muted-foreground">Only the first {PEOPLE_BOARD_LIMIT} open deliverables are loaded, so some people may be missing.</p>
      )}

      {isLoading ? (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-56 rounded-xl" />)}
        </div>
      ) : isError ? (
        <div className="rounded-xl border border-destructive/30 bg-destructive/5 p-8 text-center text-sm text-destructive">Failed to load the board.</div>
      ) : people.length === 0 ? (
        <div className="rounded-xl border border-dashed p-12 text-center text-sm text-muted-foreground">
          {search ? "Nobody matches that search." : "No committed deliverables yet — commit one with a DRI and a PPP to see people here."}
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {people.map((b) => <PersonCard key={b.user.pid} board={b} />)}
        </div>
      )}

      <UnassignedSection total={candidatesTotal} />
    </PageShell>
  );
};

export default People;
